import React, { Fragment } from 'react'
// used for making the prop types of this component
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

// core components
import Button from 'components/CustomButtons/Button.jsx'

import defaultImage from 'assets/img/icone_foto_perfil_02.png'
import defaultAvatar from 'assets/img/fazendeiro.png'

// REDIX INIT
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { SetFileData } from '../../redux/actions'
import { prototype } from 'react-transition-group/TransitionGroup'

import { GetThemeColorFromStorage } from '../../redux/api/themeColor'

class AvatarUpload extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: null,
            imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage,
        }
        this.handleImageChange = this.handleImageChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handleRemove = this.handleRemove.bind(this)
    }

    componentDidMount() {
        if (this.props.value && this.props.value !== '') {
            this.setState({ imagePreviewUrl: this.props.value, file: '' })
        }
    }

    handleImageChange = async (e) => {
        e.persist()
        e.preventDefault()
        let reader = new FileReader()
        await this.props.SetFileData(e.target.files[0])
        reader.onloadend = () => {
            this.setState({
                file: this.props.imageFile,
                imagePreviewUrl: reader.result,
            })
        }
        reader.readAsDataURL(this.props.imageFile)
    }

    handleSubmit(e) {
        e.preventDefault()
        // this.state.file is the file/image uploaded
        // in this function you can save the image (this.state.file) on form submit
        // you have to call it yourself
    }
    handleClick() {
        this.refs.fileInput.click()
    }
    handleRemove() {
        this.props.SetFileData(null)
        this.setState({
            file: null,
            imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage,
        })
        this.refs.fileInput.value = null
        if (this.props.onChange) {
            this.props.onChange()
        }
    }
    render() {
        var { t } = this.props
        return (
            <Fragment>
                <div
                    className="picture-container"
                    style={{ textAlign: 'left' }}
                >
                    <div className="picture" style={{ margin: '5px 0 0 0' }}>
                        <i
                            className="material-icons"
                            style={{
                                backgroundColor:
                                    GetThemeColorFromStorage()?.navigation
                                        ?.buttons?.backgroundColor,
                                position: 'absolute',
                                left: '84px',
                                top: '30px',
                                border: '2px',
                                padding: '8px',
                                borderRadius: '60px',
                            }}
                        >
                            camera_alt
                        </i>
                        <img
                            style={{
                                objectFit: 'cover',
                                height: '100%',
                                width: '100%',
                            }}
                            src={this.state.imagePreviewUrl}
                            className="picture-src"
                            alt="..."
                        />
                        <input
                            type="file"
                            onChange={(e) => this.handleImageChange(e)}
                            ref="fileInput"
                        />
                    </div>
                </div>
                <button
                    onClick={this.handleClick}
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'inline',
                        margin: '0',
                        padding: '0',
                    }}
                >
                    <h6 className="description">{t('BUTTON_SELECT_IMAGE')}</h6>
                </button>
                {this.state.file !== null && (
                    <Fragment>
                        {' '}
                        |{' '}
                        <button
                            onClick={this.handleRemove}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                display: 'inline',
                                margin: '0',
                                padding: '0',
                            }}
                        >
                            <h6 className="description">Remover Foto</h6>
                        </button>
                    </Fragment>
                )}
            </Fragment>
        )
    }
}

AvatarUpload.propTypes = {
    value: PropTypes.string,
}

const mapStateToProps = (state) => {
    return {
        imageFile: state.images.imageFile,
        tierDataFailed: state.tier.tierDataFailed,
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ SetFileData }, dispatch)

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation(),
)(AvatarUpload)
